export default __webpack_public_path__ + "static/media/pictogramBeaconBranch64.3aa60e59.svg";